import { initProductCardSwatches } from './initProductCardSwatches';
import { createEkSlider, productSliderSwiperOverrides } from './ekSwiperSlider';

export function initProductRecommendationsSlider(root: ParentNode = document): void {
  const sections = root.querySelectorAll<HTMLElement>('[data-product-recommendations-slider]');

  sections.forEach((sectionEl) => {
    const sectionId = sectionEl.dataset.sectionId;
    if (!sectionId) return;

    // Recently-viewed injects its cards lazily and initializes itself —
    // initializing here would create an empty slider before the cards exist.
    if (sectionEl.closest('[data-recently-viewed-section]')) return;

    if (sectionEl.dataset.sliderInit === 'true') return;
    sectionEl.dataset.sliderInit = 'true';

    const swiperEl = sectionEl.querySelector<HTMLElement>(`#recs-scroll-${sectionId}`);
    if (!swiperEl) return;

    initProductCardSwatches(sectionEl);

    // Sections whose former wrapper had a trailing pr-5 declare it via
    // data-slides-offset-after; the fp grid slider has no trailing offset.
    const hasTrailingOffset = Number.parseInt(swiperEl.dataset.slidesOffsetAfter || '0', 10) > 0;
    createEkSlider({
      sectionEl,
      sectionId,
      swiperEl,
      swiperOverrides: hasTrailingOffset ? productSliderSwiperOverrides : undefined,
    });
  });
}

// Auto-run on ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initProductRecommendationsSlider());
} else {
  initProductRecommendationsSlider();
}

// Re-run on Theme Editor section load
document.addEventListener('shopify:section:load', (e: Event) => {
  const target = (e as CustomEvent).target as ParentNode | null;
  initProductRecommendationsSlider(target || document);
});
